export default (gender, rootCategory, category) => {
    const str = [gender, rootCategory, category].filter(Boolean).join(' / ')
    return str
  }
  